var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.67025V33.3298C0 37.0032 2.27616 40 5.06629 40H21.4318C24.2219 40 26.4981 37.0032 26.4981 33.3298V29.0118C26.4981 28.2814 26.0494 27.6907 25.4946 27.6907C24.9398 27.6907 24.4911 28.2814 24.4911 29.0118V33.3298C24.4911 35.5532 23.1124 37.3684 21.4236 37.3684H5.06629C3.37752 37.3684 1.99878 35.5532 1.99878 33.3298V6.67025C1.99878 4.44683 3.37752 2.63158 5.06629 2.63158H21.4318C23.1205 2.63158 24.4993 4.44683 24.4993 6.67025V10.9882C24.4993 11.7186 24.948 12.3093 25.5028 12.3093C26.0575 12.3093 26.5062 11.7186 26.5062 10.9882V6.67025C26.5062 2.99678 24.2301 0 21.4399 0H5.06629C2.27616 0 0 2.98604 0 6.67025Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.442 29.9356C31.6378 30.1933 31.8907 30.3222 32.1517 30.3222C32.4128 30.3222 32.6657 30.1933 32.8615 29.9356L39.7063 20.9237C40.0979 20.4082 40.0979 19.5811 39.7063 19.0655L32.8615 10.0537C32.4699 9.53813 31.8417 9.53813 31.4501 10.0537C31.0585 10.5693 31.0585 11.3963 31.4501 11.9119L36.5898 18.6788H17.834C17.2792 18.6788 16.8305 19.2696 16.8305 20C16.8305 20.7304 17.2792 21.3212 17.834 21.3212H36.5817L31.442 28.0881C31.0504 28.5929 31.0504 29.4307 31.442 29.9356Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.fad09e3c9fad8f11e103cb3ed6580945.svg";
export { ForwardRef as ReactComponent };